<template lang="pug">
.mbanner
  #triangle-pics.triangle-pics
    img(src='../../assets/imgs/banner-m-02.jpg')
    .triangle-pic-slide
      img(src='../../assets/imgs/banner-m-01.jpg')
    .triangle-pic-slide
      img(src='../../assets/imgs/banner-m-02.jpg')
    .triangle-pic-slide
      img(src='../../assets/imgs/banner-m-03.jpg')
    .triangle-pic-slide
      img(src='../../assets/imgs/banner-m-04.jpg')
    .triangle-pic-slide
      img(src='../../assets/imgs/banner-m-05.jpg')
    .cover
  .banner-block
  .banner-text
    .container
      .block-title
        h1.cn 前沿社
        h1 企业家的动态交流学习社群
      .block-list
        dl
          dd 持续输入
          dd 刷新认知
          dd 创造改变
        a(href='/video')
          | 观看视频
          .triangle-right
      .notes
        p 让自己成为企业成长的动力而不是瓶颈
        p 像那些优秀科技领袖那样引领变革而不是被变革
        p 看到更多新可能，突破今天面对的成长极限
      .links
        a(href="/entry")
          | 成为会员
          .triangle-right
        //- a(href="/observer")
        //-   | 成为观察员
        //-   .triangle-right
</template>

<script>
import $ from 'jquery'

export default {
  name: 'banner',
  mounted(){
    const $pics = $('#triangle-pics');
    const playPicture = step => {
      $pics.find('.triangle-pic-slide').eq(step).addClass('active').siblings().removeClass('active');
    };

    setTimeout(() => {
      let i = 0;

      const play = () => {
        const picStep = i++ % 5;
        playPicture(picStep);
      };

      play();
      setInterval(play, 6000);

    }, 500);

  }
}
</script>

<style lang="stylus">
@keyframes moveBg {
  from {
    transform: scale(1.2) translate(2%, 5%);
  }
  to {
    transform: scale(1) translate(0%, 0%);
  }
}


.mbanner
  position relative
  color #fff

  .triangle-pics
    position relative
    width 100%
    overflow hidden
    img
      display block
      width 100%
      animation moveBg 20s linear
      animation-direction alternate
      animation-iteration-count infinite

    .triangle-pic-slide
      position absolute
      top 0
      left 0
      opacity 0
      transition opacity 2s

      &.active
        opacity 1
        transition opacity 2s

  .banner-block
    img
      width 100%
  .cover
    background rgba(0, 0, 0, .6)
    position absolute
    top 0
    right 0
    bottom 0
    left 0
  .banner-text
    position absolute
    bottom 30px
    .container
      padding-right 0
    .block-title
      display inline-block
      box-sizing border-box
      vertical-align middle
      text-align left
      h1
        font-family 'FZLTTHCJW--GB1-0'
        font-size 28px
        letter-spacing 2px
        margin-bottom 10px
        &.cn
          font-family 'FZLTTHCJW--GB1-0'
          font-size 42px
    .block-list
      box-sizing border-box
      display inline-block
      vertical-align middle
      text-align left
      dl
        padding-bottom 5px
        dd
          font-size 22px
          font-family 'Noto Sans SC', sans-serif
          font-weight 300
          display inline-block
          padding-right 20px
          &:last-child
            padding 0
      a
        font-size 16px
        font-weight bold
        color #5FC4FF

        .triangle-right
          display inline-block
          vertical-align top
          margin .1em .3em
          width 0
          height 0
          border-top .4em solid transparent
          border-left .5em solid currentColor
          border-bottom .4em solid transparent
    .notes
      font-size 12px
      line-height 1.8em
      padding-top 20px

    .links
      display flex
      justify-content space-around
      margin-top 30px
      margin-right 20px
      a
        color #5EC5FF
        display inline-block
        border 0.1em solid currentColor
        padding 0.5em 1em
        font-size 16px
        font-weight bolder
        &:hover
          color #000
          background-color #5EC5FF
          border-color #5EC5FF
@media only screen and (max-width: 320px)
  .mbanner
    .banner-text
      .block-list
        dl
          dd
            font-size 20px
            padding-right 10px
        p
          font-size 12px
</style>



// WEBPACK FOOTER //
// Banner.vue?43cd3f0e